import { NUMBER, RADIO, TEXT } from '#app/constants/forms.ts'
import {
	type Question,
	type RadioOptions,
	type ReturnTypeGetNextQuestionIdAndAnswer,
	type JSONState,
	type QuestionTreeBase,
	type QuestionMeta,
	type GetNextQuestionIdAndAnswerParams,
} from '#types/form/wizard.ts'

interface GetCurrentQuestionFromJSONStateParams<T> {
	questionTree: JSONState<T>['questionTree']
	currentQuestionTreeId: JSONState<T>['currentQuestionTreeId']
	currentQuestionId: JSONState<T>['currentQuestionId']
}

export function getCurrentQuestionFromJSONState<T>({
	questionTree,
	currentQuestionTreeId,
	currentQuestionId,
}: GetCurrentQuestionFromJSONStateParams<T>): Question {
	const currentQuestionTreeBase: QuestionTreeBase = questionTree.find(
		(tree: QuestionTreeBase) => tree.id === currentQuestionTreeId,
	)!

	let currentQuestion =
		currentQuestionTreeBase?.tree?.questions[currentQuestionId]

	if (!currentQuestion) {
		currentQuestion = currentQuestionTreeBase?.tree?.questions['A1']
	}

	return currentQuestion
}

export const getAllQuestionsFromTree = (
	tree: QuestionMeta,
	backendId: string,
) => {
	const allQuestions = Object.keys(tree.questions).map(questionId => {
		return {
			id: `${backendId}-${questionId}`,
			text: tree.questions[questionId].text,
		}
	})

	return allQuestions
}

export function getNextQuestionIdAndAnswer({
	currentFormContext,
	currentQuestion,
	fieldKey,
}: GetNextQuestionIdAndAnswerParams): ReturnTypeGetNextQuestionIdAndAnswer {
	let nextQuestionId

	if (currentQuestion.type === TEXT || currentQuestion.type === NUMBER) {
		nextQuestionId = currentQuestion.nextQuestionId
	}

	if (currentQuestion.type === RADIO) {
		let selectedOption = currentQuestion.options.find(
			(option: RadioOptions) => currentFormContext[fieldKey] === option.text,
		)

		if (!selectedOption) {
			selectedOption = currentQuestion.options.find(
				(option: RadioOptions) => currentFormContext[fieldKey] === option.id,
			)
		}

		nextQuestionId = selectedOption!.nextQuestionId
	}

	const currentAnswer = currentFormContext[fieldKey]

	if (currentQuestion && currentQuestion.type === RADIO) {
		let selectedOption = currentQuestion.options.find(
			(option: RadioOptions) => currentAnswer === option.text,
		)

		if (!selectedOption) {
			selectedOption = currentQuestion.options.find(
				(option: RadioOptions) => currentAnswer === option.id,
			)
		}

		nextQuestionId = selectedOption?.nextQuestionId
	}

	return {
		currentAnswer,
		nextQuestionId,
	} as ReturnTypeGetNextQuestionIdAndAnswer
}
